export const EVENT_MAP_ID = 'listings-root__event-location-map';
export const DEFAULT_ZOOM = 13;
export const TOGGLE_MAP_ID = 'toggle-map';
export const EVENT_LOCATION_MAP_ID = 'event-location-map';
